/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum CourseCategory {
  business_planning = 'business_planning',
  client_management = 'client_management',
  communication = 'communication',
  finance = 'finance',
  hiring = 'hiring',
  management = 'management',
  marketing = 'marketing',
  sales = 'sales',
  software_and_technology = 'software_and_technology'
}
